import { PADDING } from '~/static/enums/lines'
import { ObjectType } from '~/static/enums/object-type'
import { VersionMigrator } from '~/utils/editor/versioning/migrators'
import { ObjectPropsV1, ObjectPropsV2, migrate as migrateObject, FabricV5Data } from '~/utils/editor/versioning/object'

export enum Versions {
  V1 = 1, // data has no field 'version'
  V2 = 2,
}

export const ActualVersionNumber = Versions.V2
export type ActualVersion = LinePropsV2

export interface LinePropsV1 extends ObjectPropsV1 {
  type?: ObjectType.Line

  length?: number
  pointerHeight?: number
  width?: number
  color?: string
  opacity?: number
  dash?: boolean
  dashSize?: number[]
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  objectIndex?: number

  data?: FabricV5Data & { height?: number }
}

export interface LinePropsV2 extends ObjectPropsV2 {
  type?: ObjectType.Line

  length?: number
  height?: number
  pointerHeight?: number
  width?: number
  color?: string
  opacity?: number
  dash?: boolean
  dashSize?: number[]
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  objectIndex?: number
}

export const migrate: VersionMigrator<LinePropsV2> = (data: object) => {
  if ('version' in data && data.version === Versions.V2) {
    return data as LinePropsV2
  }

  const dataV1 = data as LinePropsV1

  return {
    type: ObjectType.Line,  
    ...migrateObject(dataV1),
    version: Versions.V2,
    title: 'Фигура',
    length: dataV1.length,
    height: dataV1.data?.height ?? (1 + PADDING * 2),
    pointerHeight: dataV1.pointerHeight,
    width: dataV1.width,
    color: dataV1.color,
    opacity: dataV1.opacity,
    dash: dataV1.dash,
    dashSize: dataV1.dashSize,
    shadow: dataV1.shadow,
    shadowColor: dataV1.shadowColor,
    shadowOpacity: dataV1.shadowOpacity,
    shadowX: dataV1.shadowX,
    shadowY: dataV1.shadowY,
    shadowBlur: dataV1.shadowBlur,
    objectIndex: dataV1.objectIndex,
  } as LinePropsV2
}
